export default __webpack_public_path__ + "media/zurb/img/playground/card-group-31b3b2bca3bcf3215518bf63b250e51b.png";